import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Settings } from 'src/app/modules/common/lib/app.constant';
import { CommonService } from 'src/app/modules/common/service/common/common.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-accessdenied',
  templateUrl: './app.accessdenied.component.html',
  styleUrls: ['./app.accessdenied.component.scss']
})
export class AppAccessdeniedComponent {
accessForm:FormGroup = new FormGroup({
      first_name: new FormControl(null, [Validators.required,Validators.maxLength(50)]),
      last_name: new FormControl(null, [Validators.required,Validators.maxLength(50)])
    });

  constructor(private commonService:CommonService,private messageService:MessageService,private route:Router){

  } 
    
  showRequestAccess:boolean=false;

  onClickRequestAccess(){
   this.showRequestAccess=true;
  }

  get isShowRequestAccessButton():boolean{
    return (environment.environmentType===Settings.EnvironmentType.DEV || environment.environmentType===Settings.EnvironmentType.PROD);
  }
  onClickSubmitRequest(){
   this.commonService.requestUserAccess(this.accessForm.value).subscribe({
    next:()=>{
    this.messageService.add(
          {
            severity: 'success',
            summary: 'Success',
            key:'emptyToster',
          detail: 'Access request submitted and user added successfully. Please wait for while we process your request.'
          });
          this.redirectToLogin();
          this.onClickHideRequestAccess();
    },
    error:(error)=>{
this.messageService.add(
          {
            severity: 'error',
            summary: 'Error',
            key:'emptyToster',
            detail: error?.error?.message??'There was an error submitting the access request. Please try again later.'
          });
          this.onClickHideRequestAccess();
    }
   })
  }

  onClickHideRequestAccess(){
    this.showRequestAccess=false;
    this.accessForm.reset();
  }

    redirectToLogin(){
      this.route.navigateByUrl('/login');
    }
}
